<template>
   <div>


     <!-- Loader -->
<div v-if="isLoading" class="spinner-overlay">
  <div class="loading-box">
<div class="spinner" :style="{ '--spinner-color': bgTheme || '#c7222a' }"></div>
    <span>Loading ...</span>
  </div>
</div>

    <div style="height: 100vh; display: flex; flex-direction: column; background-color: #f8f8f8;">
          <!-- Scrollable Content -->
      <div style="flex: 1; overflow-y: auto; padding: 10px;">
        <!-- Header -->
      <div style="display: flex; align-items: center; justify-content: start; gap: 10px; margin-bottom: 16px;">
        <div style="background-color: #f9fafb; padding: 6px 8px; border-radius: 5px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;"">
         <img style="cursor: pointer; width: 15px; height: 15px;" src="@/assets/back-icon1.png" alt="clip" class="clip-image"  @click="$router.go(-1)"/>
       </div>
        <h2 style="font-size: 14px; font-weight: 600; margin: 0;">Your Invitees</h2>
      </div>
  
      <!-- Tabs -->

    
      <div
         :style="{
    display: 'flex',
    border: `1px solid ${bgTheme ? bgTheme : '#C7222A'}`,
    borderRadius: '16px',
    overflow: 'hidden',
    marginBottom: '12px',
    padding: '5px'
  }"
      >
        <button
          v-for="tab in tabs"
          :key="tab.name"
          @click="activeTab = tab.name"
          :style="{
  flex: 1,
  padding: '8px',
  textAlign: 'center',
  fontWeight: '600',
  fontSize: '12px',
  border: 'none',
  background: activeTab === tab.name 
    ? (bgTheme ? bgTheme : '#c7222a') 
    : '#ffffff',
  color: activeTab === tab.name 
    ?  '#fff' 
    : '#888',
  // color : '#ffffff',
  cursor: 'pointer',
  borderRadius: '16px',
}"

        >
          {{ tab.label }}
        </button>
      </div>
  
       <!-- Invitee List -->
  <div
    v-for="(invitee, index) in filteredInvitees"
    :key="index"
    @click="toggleCollapse(index)"
    style="
      background: #ffffff;
      border-radius: 12px;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      padding: 12px;
      margin-bottom: 12px;
      cursor: pointer;
      transition: all 0.3s ease;
    "
  >
    <!-- Invitee Header -->
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center;">
        <div
         :style="{
  background: '#e0e0e0',
  fontWeight: 700,
  borderRadius: '50%',
  width: '40px',
  height: '40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '10px',
  fontSize: '16px',
  color: bgTheme ? bgTheme : '#C7222A'
}"

        >
          {{ getInitials(invitee.name) }}
        </div>
        <div style="font-weight: 400; font-size: 14px; color: #000000; text-align: left;">
          {{ invitee.name }}
        </div>
      </div>
     <div style="font-size: 18px; color: #999;">
  <div
    v-if="collapsedIndexes.includes(index)"
    :style="{
      width: '18px',
      height: '18px',
      backgroundColor: bgTheme, // Icon color
      WebkitMaskImage: 'url(' + asset('chevron-up.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('chevron-up.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
      cursor: 'pointer'
    }"
  ></div>

  <div
    v-else
    :style="{
      width: '18px',
      height: '18px',
      backgroundColor: bgTheme, // Icon color
      WebkitMaskImage: 'url(' + asset('chevron-down.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('chevron-down.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
      cursor: 'pointer'
    }"
  ></div>
</div>

    </div>

    <!-- Progress (collapsible content) -->
    <div
      v-if="collapsedIndexes.includes(index)"
      style="padding: 10px;"
    >
      <div
        v-for="(step, idx) in invitee.progress"
        :key="idx"
        style="display: flex; flex-direction: column; padding: 10px 0px; padding-bottom: 0px;"
      >
        <!-- Image and Text Row -->
        <div style="display: flex; align-items: center; width: 100%;">
         <img
  style="cursor: pointer; width: 20px; height: 20px; margin-right: 10px;"
  :src="step.icon"
  alt="Status"
/>


          <span
            :style="{
              color: '#000000',
              fontSize: '14px',
              fontWeight: '400',
              textAlign: 'left',
            }"
          >
            {{ step.text }}
          </span>
        </div>

        <!-- Dotted Line -->
        <div
          v-if="idx !== invitee.progress.length - 1"
          style="border-left: 2px dotted #979CAE; height: 20px; margin-left: 10px; margin-top: 10px;"
        ></div>
      </div>

     <!-- Show reward only for completed events -->
<div
  v-if="invitee.status === 'Completed'"
  style="display: flex; justify-content: center; align-items: center; gap: 3px; margin-top: 10px;"
>
  <div style="display: flex; justify-content: center; align-items: center; gap: 3px;">
    <img
      style="cursor: pointer; width: 20px; height: 20px;"
      src="@/assets/trophy.png"
      alt="Copy"
      class="logo-image"
    />
  </div>
  <p style="margin: 0; font-size: 13px; font-weight: 600; color: #bc1e6f;">
    You earned reward of ₹{{ invitee.totalAmountWon }}
  </p>
</div>



<!-- Reward Message -->
<div
  v-if="invitee.rewardMessage && invitee.status === 'Pending'"
  style="display: flex; justify-content: center; align-items: center; gap: 3px; margin-top: 15px;"
>
  <img
    style="cursor: pointer; width: 20px; height: 20px;"
    src="@/assets/trophy.png"
    alt="Reward"
    class="logo-image"
  />
  <p style="margin: 0; font-size: 13px; font-weight: 600; color: #444;">
    {{ invitee.rewardMessage }} 
  </p>
</div>


    </div>
  </div>



      <!-- 👇 Add this block below v-for -->
<div v-if="filteredInvitees.length === 0" style="text-align: center; color: #999; margin-top: 20px; height: 60vh;">
  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 80%;">
           <img
             style="cursor: pointer;"
             src="@/assets/no-inbox.png"
             alt="Copy"
             class="logo-image"
           />
   <!-- <p style="margin: 0 !important; font-size: 14px; font-weight: 600; color: #000000; ">You have no {{ activeTab }} Referrals</p> -->
        <p style="margin: 0 !important; font-size: 14px; font-weight: 600; color: #000000;">
  {{ noReferralText }}
</p>


         </div>
</div>
     
      </div>



       <!-- Fixed QR Block at Bottom -->
      <div style="background-color: #ffffff; border-top: 1px solid #eee; padding-bottom: 10px;">
         <p style="margin: 15px !important; text-align: center; font-size: 12px; font-weight: 600; color: #000000;">Invite your friends via</p>
         <div style="display: flex; padding: 10px; justify-content: space-evenly; align-items: center; padding-top: 0px;">
          <div @click="showQrPopup = true" style="text-align: center;">
 <div
  :style="{
    width: '40px',
    height: '40px',
    margin: 'auto',
    backgroundColor: bgTheme, // Background color
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '5px',
  }"
>
  <div
    :style="{
      width: '20px',
      height: '20px',
      backgroundColor: 'white', // Icon color
      WebkitMaskImage: 'url(' + asset('qr-img1.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('qr-img1.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
</div>

  <p style="margin: 0px !important; font-size: 10px; font-weight: bold;">QR Code</p>
</div>

          <div @click="getShareMsg(offerData.id, 'cp')" style="text-align: center;">
 <div
  :style="{
    width: '40px',
    height: '40px',
    margin: 'auto',
    backgroundColor: bgTheme, // Background color
    borderRadius: '50%',     // Make it circular
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '5px',
  }"
>
  <div
    :style="{
      width: '20px',  // Icon size
      height: '20px',
      backgroundColor: 'white', // Icon color
      WebkitMaskImage: 'url(' + asset('copy-img1.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('copy-img1.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
</div>

  <p style="margin: 0px !important; font-size: 10px; font-weight: bold;">Copy link</p>
</div>

           <div @click="showSharePopup = true" style="text-align: center;">
  <div
    :style="{
      width: '40px',
      height: '40px',
      margin: 'auto',
      backgroundColor: bgTheme, // Background color (same as share button)
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      marginBottom: '5px',
    }"
  >
    <div
      :style="{
        width: '20px',
        height: '20px',
        backgroundColor: 'white', // Icon color
        WebkitMaskImage: 'url(' + asset('share-img1.png') + ')',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskImage: 'url(' + asset('share-img1.png') + ')',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
      }"
    ></div>
  </div>
  <p style="margin: 0px !important; font-size: 10px; font-weight: bold;">Share</p>
</div>

         </div>
       </div>

        <!-- QR Code Popup -->
<div v-if="showQrPopup" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: flex-end;">
   <div style="background: white; border-radius: 40px 40px 0 0; width: 100%; max-width: 400px; text-align: center; position: relative; padding: 16px; padding-bottom: 5px;">
  
     <!-- Go Back Button (centered above popup) -->
<button @click="showQrPopup = false"
 :style="{
  position: 'absolute',
  top: '-55px',
  left: '50%',
  transform: 'translateX(-50%)',
  background: 'white',
  color: bgTheme,
  border: 'none',
  borderRadius: '50px',
  padding: '11px 16px',
  fontSize: '14px',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
  cursor: 'pointer',
  fontWeight: '700',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px'
}"
>
  <!-- Chevron Left Icon -->
  <div
    :style="{
      width: '16px',
      height: '16px',
      backgroundColor: bgTheme, // dynamic button color
      WebkitMaskImage: 'url(' + asset('chevron-left-red.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('chevron-left-red.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
  Go back
</button>

  
     <div style="display: flex; justify-content: center; margin-bottom: 10px;">
      <div style="border: 1px solid #797979; width: 32px;">
         
      </div>
     </div>
  
     <div>
       <img
         style="cursor: pointer; width: 144px; height: 66px;"
         :src="offerData.offer.qr_popup_logo"
         alt="Share"
         class="logo-image"
       />
     </div>
  
     <p style="font-size: 16px; color: #666; margin: 0; font-weight: 400; color: #2E2E2E;">{{ offerData.offer.qr_popup_title }}</p>
  
     <div style="display: flex; flex-direction: column; padding: 10px;">
       <!-- QR Code Image --> 
       <img
         :src="offerData.offer.qr_code"
         alt="QR Code"
         style="width: 220px; margin: 0px auto; border: 2px solid #797979; border-radius: 10px; height: 220px;"
       />
  
       <div
       @click="showSharePopup = true"
        :style="{
  background: bgTheme ? bgTheme : '#c7222a',
  color: 'white',
  border: 'none',
  borderRadius: '50px',
  padding: '10px 20px',
  fontSize: '14px',
  marginTop: '20px',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px'
}"
>
        <img
               style="cursor: pointer; width: 20px; height: 20px;"
               src="@/assets/share-variant.png"
               alt="QR Code"
               class="logo-image"
             />
             <p style="margin: 0; font-size: 16px; font-weight: 600;"> Share QR Code</p>
       </div>
     </div>
   </div>
  </div>


<!-- Share Popup -->
<div v-if="showSharePopup" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: flex-end;">
   <div
     style="
       position: relative;
       width: 100%;
       max-width: 400px;
       background: white;
       border-top-left-radius: 20px;
       border-top-right-radius: 20px;
       box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
       text-align: center;
       padding: 20px 0px;
     "
   >
     <!-- Go Back Button (centered above popup) -->
     <button @click="showSharePopup = false"
 :style="{
  position: 'absolute',
  top: '-55px',
  left: '50%',
  transform: 'translateX(-50%)',
  background: 'white',
  color: bgTheme,
  border: 'none',
  borderRadius: '50px',
  padding: '11px 16px',
  fontSize: '14px',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
  cursor: 'pointer',
  fontWeight: '700',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px'
}"
>
  <!-- Chevron Left Icon -->
  <div
    :style="{
      width: '16px',
      height: '16px',
      backgroundColor: bgTheme, // dynamic button color
      WebkitMaskImage: 'url(' + asset('chevron-left-red.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('chevron-left-red.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
  Go back
</button>
  
     <p style="font-weight: bold; margin: 10px 0;">Share via</p>
  
     <!-- Share Options -->
     <div style="display: flex; justify-content: space-evenly; margin-top: 15px;">
       <!-- Facebook -->
       <div 
       @click="getShareMsg(offerData.id, 'wa')"
style="cursor: pointer;">
         <!-- <img :src="offerData.share_options[0].icon" alt="Facebook" style="width: 40px; height: 40px;" /> -->
           <img
               style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
               src="@/assets/whatsapp.png"
               alt="back"
               class="logo-image"
             />
         <p style="margin: 5px 0; font-size: 12px;">{{ offerData.share_options[0].text }}</p>
       </div>
       <!-- Twitter -->
       <div  @click="getShareMsg(offerData.id, 'fb')"style="cursor: pointer;">
         <!-- <img :src="offerData.share_options[1].icon" alt="Twitter" style="width: 40px; height: 40px;" /> -->
          <img
                style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
               src="@/assets/facebook.png"
               alt="back"
               class="logo-image"
             />
         <p style="margin: 5px 0; font-size: 12px;">{{ offerData.share_options[1].text }}</p>
       </div>
       <!-- Gmail -->
       <div @click="getShareMsg(offerData.id, 'ig')" style="cursor: pointer;">
         <!-- <img :src="offerData.share_options[2].icon" alt="Gmail" style="width: 40px; height: 40px;" /> -->
          <img
                style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
               src="@/assets/instagram.png"
               alt="back"
               class="logo-image"
             />
         <p style="margin: 5px 0; font-size: 12px;">{{ offerData.share_options[2].text }}</p>
       </div>
     </div>
   </div>
  </div>



<div id="copied-toast" class="font-bold pos-fixed pos-center-hor pull-down" style="width: 100px; padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.3); margin-bottom: 70px; color: white; display: none; bottom: 10%;">
         Link Copied
       </div>

      
    </div>
   </div>
  </template>
  
  <script>
import { asset } from "@/utils/asset";
  import { faL } from '@fortawesome/free-solid-svg-icons';
  import greenTick from "@/assets/green-tick.png";
import redCross from "@/assets/red-cross.png";
import greyTick from "@/assets/grey-tick.png";
import { globals } from "@/mixins/globals"

import axios from 'axios';
  
  export default {
    name: "seeInvites",
     mixins: [globals],
  
    data() {
      return {
         offerData: null,
      activeTab: "Pending",
      collapsedIndexes: [], // Will be filled when data loads
      tabs: [
        { name: "Pending", label: "Pending (0)" },
        { name: "Completed", label: "Completed (0)" },
        { name: "Expired", label: "Expired (0)" },
      ],
      invitees: [], // API data
      page: 1,
      hasMoreData: true,
      isLoading: false,
      showQrPopup: false,
      showSharePopup: false,
      // isButtonColour: "",
      // isButtonTextColour: "",
      };
     
    },
  
    computed: {

       sdkEvent() {
      return this.$store.state.sdkEvent;
    },

     isButtonColour() {
  if (this.sdkEvent && this.sdkEvent.isButtonColour) {
    return this.sdkEvent.isButtonColour;
  }
  return '#C7222A';
},

  isButtonTextColour() {
  if (this.sdkEvent && this.sdkEvent.isButtonTextColour) {
    return this.sdkEvent.isButtonTextColour;
  }
  return '#ffffff';
},


        noReferralText() {
      return this.activeTab === "Pending"
        ? "You have no Referrals"
        : `You have no ${this.activeTab} Referrals`;
    },
    filteredInvitees() {
      return this.invitees.filter(
        (invitee) => invitee.status === this.activeTab
      );
    },
    },
  
    methods: {      
          toggleCollapse(index) {
      const i = this.collapsedIndexes.indexOf(index);
      if (i > -1) this.collapsedIndexes.splice(i, 1);
      else this.collapsedIndexes.push(index);
    },

    // This will open all invitees by default
    openAllInvitees() {
      this.collapsedIndexes = this.filteredInvitees.map((_, index) => index);
    },
  
      getInitials(name) {
        return name
          .split(" ")
          .map(n => n[0])
          .join("")
          .toUpperCase();
      },
  
      handleScroll(e) {
        const target = e.target;
        if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
          // this.getReferralHistory(this.page);
        }
      },



      getReferralHistory(page = 1) {
  this.isLoading = true;
  const url = this.$store.getters.flyyDomain + `/v2/referral_history`;
  const headers = this.$store.getters.headers;

  axios
    .get(url, {
      mode: "no-cors",
      headers,
      params: { page },
    })
    .then((resp) => {
      if (resp.data.success) {
        const newReferrals = resp.data.referrals || [];

        const newInvitees = newReferrals.map((ref) => {
          const offerEvents = ref.offer_events || [];
          const completed = offerEvents.filter(e => e.is_completed).length;
          const total = offerEvents.length;

          // Determine status
          let status = "Pending";
          const anyFailed = offerEvents.some(e => e.failed_referral);
          const allIncomplete = offerEvents.every(e => !e.is_completed);

          if (completed === total && total > 0) {
            status = "Completed";
          } else if (anyFailed || allIncomplete) {
            status = "Expired";
          }

          // Determine reward message (like Rajesh Garg in your screenshot)
          let rewardMessage = null;
          if (total > 0 && completed === total - 1 && !offerEvents[total - 1].is_completed) {
            const firstEventDate = offerEvents[0] && offerEvents[0].event_date;
            if (firstEventDate) {
              // rewardMessage = `Reward will be credited by ${this.formatDate(firstEventDate, 30)}`;
              rewardMessage = `Reward will be credited by ${this.formatDateWithOffset(firstEventDate, 30)}`;

            }
          }

          return {
            name: ref.user_name,
            totalAmountWon: ref.total_amount_won,
            status,
            rewardMessage, // Include reward message
            progress: offerEvents.map((e) => {
              let icon = greyTick; // Default grey tick
              if (e.is_completed && !e.failed_referral) {
                icon = greenTick;
              } else if (e.failed_referral) {
                icon = redCross;
              }
              return {
                text: `${e.name}${e.event_date ? `: ${this.formatDate(e.event_date)}` : ''}`,
                icon,
              };
            }),
          };
        });

        this.invitees = [...this.invitees, ...newInvitees];

        const pendingCount = this.invitees.filter(i => i.status === "Pending").length;
        const completedCount = this.invitees.filter(i => i.status === "Completed").length;
        const expiredCount = this.invitees.filter(i => i.status === "Expired").length;

        this.openAllInvitees();

        this.tabs = [
          { name: "Pending", label: `Pending (${pendingCount})` },
          { name: "Completed", label: `Completed (${completedCount})` },
          { name: "Expired", label: `Expired (${expiredCount})` },
        ];
      }
    })
    .catch((err) => {
      console.error("Referral history fetch failed", err);
    })
    .finally(() => {
      this.isLoading = false;
    });
},

formatDateWithOffset(dateStr, daysToAdd = 0) {
  const date = new Date(dateStr);
  date.setDate(date.getDate() + daysToAdd); // Add days

  const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear().toString().slice(-2);

  // Add ordinal suffix (st, nd, rd, th)
  const suffix = (d => {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  })(day);

  return `${day}${suffix} ${month}'${year}`;
},



formatDate(dateStr) {
  const date = new Date(dateStr);

  const day = date.getDate();
  const month = date.toLocaleString("en-IN", { month: "short" });
  const year = date.getFullYear().toString().slice(-2);

  // Get ordinal suffix
  const suffix =
    day === 1 || day === 21 || day === 31 ? "st" :
    day === 2 || day === 22 ? "nd" :
    day === 3 || day === 23 ? "rd" : "th";

  return `${day}${suffix} ${month}'${year}`;
}


    },
  
    created() {

       this.isLoading = true;
      const data = this.$route.query.data;
      if (data) {
        try {
          this.offerData = JSON.parse(data);
        } catch (e) {
          console.error("Invalid data passed:", e);
        }
      }
  
      this.getReferralHistory(this.page);
    },
  
    mounted() {

      //  this.isButtonColour = this.sdkEvent.isButtonColour
      //  this.isButtonTextColour = this.sdkEvent.isButtonTextColour



        this.fetchInvitees(); // Fetch data when component mounts
      const scrollContainer = this.$el.querySelector('[style*="overflow-y: auto"]');
      if (scrollContainer) {
        scrollContainer.addEventListener('scroll', this.handleScroll);
      }
    },
  
    beforeDestroy() {
      const scrollContainer = this.$el.querySelector('[style*="overflow-y: auto"]');
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', this.handleScroll);
      }
    }
  };
  </script>
  
  